<template>
<div id="modal_wrapper" v-show="visible === true" class="modal-loader-wrapper">
                            <div id="modal_panel" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
								<div class="panel panel-warning ">
									<div class="panel-heading">
										<h3 class="panel-title">{{modal_title}}</h3>
									</div>
									<div class="panel-body">
										{{msg}}
									</div>
								</div>    
				             </div>    
</div>	
</template>


<script>
export default {
  name: 'modalnotify',
  props: {
      visible: {
            type:Boolean
              },
      msg : {
          type : String
      },      
      modal_title : {
          type : String
      }
  },
 watch: {
 
      visible : function (val) {

            if (val)
               {   
                 var y = $('body').height();
                 $("#modal_wrapper").height(y);
                 var x = $('body').width();   
                 $("#modal_wrapper").width(x);
                               
                   
                   
               }
      }
    
}    
}
</script>
<style>
.modal-loader-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.9);
  z-index: 10000;
}
</style>




// WEBPACK FOOTER //
// src/components/supportcomp/modalnotify.vue